import { ProfileContext } from "../../Context";
import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { UserTypeEnum } from "../../Structures";

interface ProfileLayoutProps {
  children: JSX.Element | JSX.Element[];
}

interface ProfileMenu {
  path: string;
  title: string;
  icon: string;
}

type ProfileLayoutComponent = (props: ProfileLayoutProps) => JSX.Element;

const ProfileLayout: ProfileLayoutComponent = ({ children }) => {
  const location = useLocation();

  const { profile } = useContext(ProfileContext);

  // ====================================================

  const getFullname = () => {
    if (profile.first_name && profile.last_name) {
      return profile.first_name + " " + profile.last_name;
    }
    return "لطفا احراز هویت کنید";
  };

  // ====================================================

  const profileMenu = (): ProfileMenu[] => {
    const baseMenu = [
      [
        {
          icon: "person",
          path: "/profile",
          title: "اطلاعات کاربری",
        },
        {
          icon: "key",
          path: "/change-password",
          title: "رمز عبور",
        },
      ],
    ];

    switch (profile.user_type) {
      case UserTypeEnum.USER: {
        baseMenu.push([
          {
            icon: "people",
            path: "/my-information",
            title: "اطلاعات تکمیلی",
          },
          // {
          //   icon: "hr",
          //   path: "/my-rules",
          //   title: "حکم‌های من",
          // },
          {
            icon: "calendar-event",
            path: "/my-events",
            title: "رویداد‌های ثبت‌نامی",
          },
          {
            icon: "receipt",
            path: "/payment-history",
            title: "تاریخچه پرداخت‌ها",
          },
          {
            icon: "door-open",
            path: "/coach-register",
            title: "ثبت‌نام به عنوان مربی",
          },
        ]);
        break;
      }
      case UserTypeEnum.COACH: {
        baseMenu.push([
          {
            icon: "info-circle-fill",
            path: "/coach-information",
            title: "اطلاعات مربی",
          },
          {
            icon: "person-fill",
            path: "/my-members",
            title: "هنرجوهای من",
          },
          {
            icon: "calendar-event",
            path: "/my-events",
            title: "رویداد‌های ثبت‌نامی",
          },
          {
            icon: "door-open",
            path: "/coach-plans",
            title: "خرید اشتراک",
          },
          {
            icon: "receipt",
            path: "/payment-history",
            title: "تاریخچه پرداخت‌ها",
          },
        ]);
        break;
      }
      case UserTypeEnum.RESPONSIBLE: {
        baseMenu.push([
          {
            icon: "people-fill",
            path: "/responsible-students",
            title: "هنرجو ها",
          },
        ]);
      }
    }

    return baseMenu.flat();
  };

  // ==============================================================================

  return (
    <div className="container py-4">
      <div className="col-12">
        <div className="card mb-1 position-relative z-index-9">
          <div
            className="py-5 h-200 rounded-3"
            style={{
              backgroundImage: "url(/imgs/blog/16by9/big/07.jpg)",
              backgroundPosition: " center bottom",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
          <div className="card-body pt-3 pb-0">
            <div className="row d-flex justify-content-between">
              {profile.profile ? (
                <div className="col-sm-12 col-md-auto text-center text-md-start">
                  <div className="avatar mx-auto avatar-xxl mt-n5">
                    <img
                      className="avatar-img rounded-circle border border-white border-3 shadow"
                      src={profile.profile}
                      alt="profile image"
                    />
                  </div>
                </div>
              ) : (
                <div className="btn btn-primary-soft btn-round mb-0 d-flex justify-content-center align-items-center">
                  <i className="bi-person fs-5 d-flex"></i>
                </div>
              )}

              <div className="w-100 col-md text-center text-md-start d-md-flex justify-content-between align-items-center">
                <div>
                  <h4 className="my-1">
                    {getFullname()}
                    {profile.personalVerification ? (
                      <i className="bi bi-patch-check-fill mx-2 text-info small" />
                    ) : null}
                  </h4>
                  {profile.personalVerification ? (
                    <ul className="list-inline">
                      <li className="list-inline-item">
                        {profile.phoneNumber}
                      </li>
                    </ul>
                  ) : null}
                  <p className="m-0"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="row">
        {/* {profile.user_type != UserTypeEnum.RESPONSIBLE ? ( */}
        <div className="col-lg-3">
          <div className="row w-100 mb-lg-0 mb-3 mx-auto">
            <div className="list-group p-0 rounded-3">
              {profileMenu().map((item: ProfileMenu) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`list-group-item py-3 d-flex align-items-center list-group-item-action ${
                    item.path == location.pathname ? "btn-info-soft" : ""
                  }`}
                >
                  <i className={`bi bi-${item.icon} d-flex`}></i>
                  {item.title}
                </Link>
              ))}
            </div>
          </div>
        </div>
        {/* ) : null} */}

        {/* <div
          className={`${
            profile.user_type != UserTypeEnum.RESPONSIBLE ? "col-lg-9" : ""
          } col-12`}
        > */}
        <div className="col-lg-9 col-12">{children}</div>
      </div>
    </div>
  );
};

export default ProfileLayout;
